import { contentLabelsSelector } from "@/redux/loadedContent/loadedContentSlice";
import { chemStyleCategories, chemStyleIds } from "@repo/shared/utils";
import { useSelector } from "react-redux";

import { ChemStyleBox } from "../../../../organisms/SquadBuilder/SelectChemStyle/ChemStyleBox";

type Props = {
  selected: number;
  onSelect: (selected: number) => void;
  chemStyleToMetaRating: {
    [key: number]: number;
  };
  isGoalKeeper: boolean;
  bestChemStyle: number;
};

export const ChemStyleOptions = ({
  selected,
  onSelect,
  chemStyleToMetaRating,
  isGoalKeeper,
  bestChemStyle,
}: Props) => {
  const { chemstyles } = useSelector(contentLabelsSelector);
  return (
    <div className="flex flex-col w-[240px] sb-v2-lg:w-[288px] gap-y-2">
      {Object.entries(chemStyleCategories).map(([category, ids]) =>
        (isGoalKeeper && category !== "Goalkeeper") ||
        (!isGoalKeeper && category === "Goalkeeper") ? null : (
          <div key={category}>
            <span className="px-2 text-xs font-medium">
              {chemstyles[ids[0]]?.groupName ?? category}
            </span>
            <div className="grid w-full grid-cols-2 gap-1">
              {chemStyleIds
                .filter((id) => ids.includes(id))
                .map((chemStyleId) => (
                  <ChemStyleBox
                    key={chemStyleId}
                    label={chemstyles[chemStyleId]?.name ?? ""}
                    chemStyleId={chemStyleId}
                    metaRating={chemStyleToMetaRating[chemStyleId] || 0}
                    isBestChemStyle={bestChemStyle === chemStyleId}
                    selected={selected === chemStyleId}
                    onClick={() => onSelect(chemStyleId)}
                  />
                ))}
            </div>
          </div>
        ),
      )}
    </div>
  );
};
